/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OutlookCalendarService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Outlook Notification
   * @param id
   * @param validationToken validation token
   * @returns any Successful Response
   * @throws ApiError
   */
  public outlookNotificationV1WorkspaceSlugIntegrationsIdOutlookNotificationPost(
    id: number,
    validationToken?: string | null
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integrations/{id}/outlook-notification',
      path: {
        id: id,
      },
      query: {
        validationToken: validationToken,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Outlook Lifecycle Notification
   * @param id
   * @param validationToken validation token
   * @returns any Successful Response
   * @throws ApiError
   */
  public outlookLifecycleNotificationV1WorkspaceSlugIntegrationsIdOutlookLifecycleNotificationPost(
    id: number,
    validationToken?: string | null
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integrations/{id}/outlook-lifecycle-notification',
      path: {
        id: id,
      },
      query: {
        validationToken: validationToken,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * Outlook Notification
   * @param id
   * @param validationToken validation token
   * @returns any Successful Response
   * @throws ApiError
   */
  public outlookNotificationV1WorkspaceSlugIntegrationIdOutlookNotificationPost(
    id: number,
    validationToken?: string | null
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integration/{id}/outlook-notification',
      path: {
        id: id,
      },
      query: {
        validationToken: validationToken,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * Outlook Lifecycle Notification
   * @param id
   * @param validationToken validation token
   * @returns any Successful Response
   * @throws ApiError
   */
  public outlookLifecycleNotificationV1WorkspaceSlugIntegrationIdOutlookLifecycleNotificationPost(
    id: number,
    validationToken?: string | null
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integration/{id}/outlook-lifecycle-notification',
      path: {
        id: id,
      },
      query: {
        validationToken: validationToken,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
